import { render, staticRenderFns } from "./output-category.vue?vue&type=template&id=35c70516&lang=pug&"
import script from "./output-category.vue?vue&type=script&lang=js&"
export * from "./output-category.vue?vue&type=script&lang=js&"
import style0 from "./output-category.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
